/**
 * OnboardingBanner - the slim reminder at the top of the app for a user who has not finished the
 * setup guide. "Continue setup" opens /welcome; the X snoozes the reminder for this browser session.
 */
import { X } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../../../components/ui/button';
import { WELCOME_PATH } from '../lib/onboardingGate';

export interface OnboardingBannerProps {
  onDismiss(): void;
}

export function OnboardingBanner({ onDismiss }: OnboardingBannerProps) {
  return (
    <div
      role="region"
      aria-label="Setup reminder"
      className="flex flex-shrink-0 flex-wrap items-center gap-2 border-b border-border bg-muted px-3 py-2 sm:px-4 lg:px-6"
    >
      <p className="min-w-0 flex-1 basis-60 text-sm text-foreground">
        Finish setting up ReturnCatalyst — talk with your setup guide
      </p>
      <Button asChild size="sm">
        <Link to={WELCOME_PATH}>Continue setup</Link>
      </Button>
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="h-9 w-9"
        aria-label="Dismiss setup reminder"
        onClick={onDismiss}
      >
        <X className="h-4 w-4" aria-hidden="true" />
      </Button>
    </div>
  );
}
